// extracted by mini-css-extract-plugin
module.exports =  {"avatarContainer":"style-module_avatarContainer__MaRkJMG0_TEpkmXJV4ai"};